module.exports = __webpack_public_path__ + "images/stable-default.b6a2003f16f887f2cc1b38de781dee8b.png";